import { Typography } from '@mui/material';

export const Spacer = () => (
  <Typography aria-hidden sx={{ flexGrow: 1 }}>
    &nbsp;
  </Typography>
);
